module.exports = __webpack_public_path__ + "static/OneDot-Light.a3456662.eot";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDot-Light.eot
// module id = 732
// module chunks = 114276838955818